// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 900;
  src: url('DMSans-Black.488392488fc1755c.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 800;
  src: url('DMSans-ExtraBold.a5b0ab310755ef77.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 700;
  src: url('DMSans-Bold.5d8f19212e66f41c.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 600;
  src: url('DMSans-SemiBold.ba81386aaa3f8bec.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 500;
  src: url('DMSans-Medium.6e411356edf4bc5d.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 400;
  src: url('DMSans-Regular.254fafcf32e78d93.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 300;
  src: url('DMSans-Light.195d851006084602.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 200;
  src: url('DMSans-ExtraLight.a1df2f9a2054461d.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 100;
  src: url('DMSans-Thin.a9d11007dfa31cfb.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: italic;
  font-weight: 900;
  src: url('DMSans-BlackItalic.6085069ea3ad7499.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: italic;
  font-weight: 800;
  src: url('DMSans-ExtraBoldItalic.43c17c588c612b92.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: italic;
  font-weight: 700;
  src: url('DMSans-BoldItalic.05455c47a70f72be.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: italic;
  font-weight: 600;
  src: url('DMSans-SemiBoldItalic.7afda8ff11873b51.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: italic;
  font-weight: 500;
  src: url('DMSans-MediumItalic.2f9b70a7382ac1bd.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: italic;
  font-weight: 400;
  src: url('DMSans-Italic.da827be69095140a.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: italic;
  font-weight: 300;
  src: url('DMSans-LightItalic.9ac218ec8d449389.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: italic;
  font-weight: 200;
  src: url('DMSans-ExtraLightItalic.201c8891fc6a2a4e.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: italic;
  font-weight: 100;
  src: url('DMSans-ThinItalic.65c007651b2972db.ttf');
}
/* Old palette
\$accent-btn: #DD7EB0;
\$dark-text: #303f71;
\$light-text: #fff;
\$inactive-text: #A3AED0;
\$accent-blue: #84D9FD;*/
@font-face {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 900;
  src: url('DMSans-Black.488392488fc1755c.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 800;
  src: url('DMSans-ExtraBold.a5b0ab310755ef77.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 700;
  src: url('DMSans-Bold.5d8f19212e66f41c.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 600;
  src: url('DMSans-SemiBold.ba81386aaa3f8bec.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 500;
  src: url('DMSans-Medium.6e411356edf4bc5d.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 400;
  src: url('DMSans-Regular.254fafcf32e78d93.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 300;
  src: url('DMSans-Light.195d851006084602.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 200;
  src: url('DMSans-ExtraLight.a1df2f9a2054461d.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 100;
  src: url('DMSans-Thin.a9d11007dfa31cfb.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: italic;
  font-weight: 900;
  src: url('DMSans-BlackItalic.6085069ea3ad7499.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: italic;
  font-weight: 800;
  src: url('DMSans-ExtraBoldItalic.43c17c588c612b92.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: italic;
  font-weight: 700;
  src: url('DMSans-BoldItalic.05455c47a70f72be.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: italic;
  font-weight: 600;
  src: url('DMSans-SemiBoldItalic.7afda8ff11873b51.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: italic;
  font-weight: 500;
  src: url('DMSans-MediumItalic.2f9b70a7382ac1bd.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: italic;
  font-weight: 400;
  src: url('DMSans-Italic.da827be69095140a.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: italic;
  font-weight: 300;
  src: url('DMSans-LightItalic.9ac218ec8d449389.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: italic;
  font-weight: 200;
  src: url('DMSans-ExtraLightItalic.201c8891fc6a2a4e.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: italic;
  font-weight: 100;
  src: url('DMSans-ThinItalic.65c007651b2972db.ttf');
}
/* Old palette
\$accent-btn: #DD7EB0;
\$dark-text: #303f71;
\$light-text: #fff;
\$inactive-text: #A3AED0;
\$accent-blue: #84D9FD;*/
/*
\$theme-darkGray: #7D7979;
\$theme-lightGray: #BDBDBD;
\$theme-peach: #FFF2E1;
\$theme-yellow: #FFBB64;
\$theme-orange: #FF9001;
\$theme-blue: #2A296F;
\$sub-header-theme: #95a5a6;*/
.banner-container {
  display: flex;
  justify-content: center; /* Center banner horizontally */
  align-items: center; /* Center vertically */
  padding: 20px;
  border-radius: 25px;
  background-size: cover;
  background-position: center;
  color: white;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.4);
  height: 100px;
  background-color: white;
  border: 1px solid #0CAD99;
}

.banner-content {
  display: flex;
  flex-direction: column; /* Stack content vertically */
  align-items: center; /* Center all elements horizontally */
  width: 100%;
  height: 100%;
}

.logo {
  max-height: 150px;
}

h1 {
  font-size: 2rem;
  margin: 0;
  text-align: center; /* Center title text */
}

.grid-container {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.grid-item {
  display: flex;
  flex-direction: column; /* Stack content in small items */
  justify-content: center;
  align-items: center;
  color: white;
  font-size: 1rem;
}

.grid-item.large {
  display: flex;
  margin: 0 20px;
}

.logo-container {
  display: flex;
  flex-direction: row;
}

.grid-item.small {
  max-height: 150px;
  margin: 0 10px;
}

.side-image {
  max-height: 75px;
  max-width: 150px;
  object-fit: contain;
}

@media screen and (max-width: 767.7px) {
  .grid-container {
    grid-template-columns: 1fr; /* Stack all items in one column */
    grid-template-rows: auto; /* Let rows adjust automatically */
  }
  .grid-item.large {
    grid-column: 1/2;
    grid-row: 1/2; /* Title takes the first row */
  }
  .grid-item.small {
    grid-column: 1/2; /* Small items stacked below */
    grid-row: auto;
  }
}
@media screen and (max-width: 1023.7px) {
  h1 {
    font-size: 1.5rem; /* Adjust title size for medium screens */
  }
}
@media (max-width: 767px) {
  .banner-container {
    height: -moz-fit-content;
    height: fit-content;
  }
  .grid-container {
    display: flex;
    flex-direction: column;
  }
}`, "",{"version":3,"sources":["webpack://./src/theme/fonts.scss","webpack://./src/app/lbarometer/shared/lb-banner/lb-banner.component.scss","webpack://./src/theme/variables.scss","webpack://./src/app/lbarometer/styles.scss"],"names":[],"mappings":"AAAA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,6CAAA;ACCF;ADEA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,iDAAA;ACAF;ADGA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,4CAAA;ACDF;ADIA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,gDAAA;ACFF;ADKA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,8CAAA;ACHF;ADMA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,+CAAA;ACJF;ADOA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,6CAAA;ACLF;ADQA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,kDAAA;ACNF;ADSA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,4CAAA;ACPF;ADUA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,mDAAA;ACRF;ADWA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,uDAAA;ACTF;ADYA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,kDAAA;ACVF;ADaA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,sDAAA;ACXF;ADcA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,oDAAA;ACZF;ADeA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,8CAAA;ACbF;ADgBA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,mDAAA;ACdF;ADiBA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,wDAAA;ACfF;ADkBA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,kDAAA;AChBF;ACpGA;;;;;uBAAA;AFPA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,6CAAA;ACmHF;ADhHA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,iDAAA;ACkHF;AD/GA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,4CAAA;ACiHF;AD9GA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,gDAAA;ACgHF;AD7GA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,8CAAA;AC+GF;AD5GA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,+CAAA;AC8GF;AD3GA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,6CAAA;AC6GF;AD1GA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,kDAAA;AC4GF;ADzGA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,4CAAA;AC2GF;ADxGA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,mDAAA;AC0GF;ADvGA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,uDAAA;ACyGF;ADtGA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,kDAAA;ACwGF;ADrGA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,sDAAA;ACuGF;ADpGA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,oDAAA;ACsGF;ADnGA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,8CAAA;ACqGF;ADlGA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,mDAAA;ACoGF;ADjGA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,wDAAA;ACmGF;ADhGA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,kDAAA;ACkGF;ACtNA;;;;;uBAAA;ACPA;;;;;;;4BAAA;AFMA;EACE,aAAA;EACA,uBAAA,EAAA,+BAAA;EACA,mBAAA,EAAA,sBAAA;EACA,aAAA;EACA,mBAAA;EACA,sBAAA;EACA,2BAAA;EACA,YAAA;EACA,yCAAA;EACA,aAAA;EACA,uBAAA;EACA,yBAAA;AAuOF;;AApOA;EACE,aAAA;EACA,sBAAA,EAAA,6BAAA;EACA,mBAAA,EAAA,qCAAA;EACA,WAAA;EACA,YAAA;AAuOF;;AApOA;EAEE,iBAAA;AAsOF;;AAnOA;EACE,eAAA;EACA,SAAA;EACA,kBAAA,EAAA,sBAAA;AAsOF;;AAnOA;EACE,WAAA;EACA,YAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;AAsOF;;AAlOA;EAEE,aAAA;EACA,sBAAA,EAAA,iCAAA;EACA,uBAAA;EACA,mBAAA;EACA,YAAA;EACA,eAAA;AAoOF;;AAjOA;EACE,aAAA;EACA,cAAA;AAoOF;;AAjOA;EACE,aAAA;EACA,mBAAA;AAoOF;;AAjOA;EACE,iBAAA;EACA,cAAA;AAoOF;;AAjOA;EAEE,gBAAA;EACA,gBAAA;EACA,mBAAA;AAmOF;;AA9NA;EACE;IACE,0BAAA,EAAA,kCAAA;IACA,wBAAA,EAAA,kCAAA;EAiOF;EA9NA;IACE,gBAAA;IACA,aAAA,EAAA,8BAAA;EAgOF;EA7NA;IACE,gBAAA,EAAA,8BAAA;IACA,cAAA;EA+NF;AACF;AA5NA;EACE;IACE,iBAAA,EAAA,yCAAA;EA8NF;AACF;AA3NA;EACE;IACE,wBAAA;IAAA,mBAAA;EA6NF;EA3NA;IACE,aAAA;IACA,sBAAA;EA6NF;AACF","sourcesContent":["@font-face {\n  font-family: 'DM Sans';\n  font-style: normal;\n  font-weight: 900;\n  src: url('../assets/DM_Sans/static/DMSans-Black.ttf');\n}\n\n@font-face {\n  font-family: 'DM Sans';\n  font-style: normal;\n  font-weight: 800;\n  src: url('../assets/DM_Sans/static/DMSans-ExtraBold.ttf');\n}\n\n@font-face {\n  font-family: 'DM Sans';\n  font-style: normal;\n  font-weight: 700;\n  src: url('../assets/DM_Sans/static/DMSans-Bold.ttf');\n}\n\n@font-face {\n  font-family: 'DM Sans';\n  font-style: normal;\n  font-weight: 600;\n  src: url('../assets/DM_Sans/static/DMSans-SemiBold.ttf');\n}\n\n@font-face {\n  font-family: 'DM Sans';\n  font-style: normal;\n  font-weight: 500;\n  src: url('../assets/DM_Sans/static/DMSans-Medium.ttf');\n}\n\n@font-face {\n  font-family: 'DM Sans';\n  font-style: normal;\n  font-weight: 400;\n  src: url('../assets/DM_Sans/static/DMSans-Regular.ttf');\n}\n\n@font-face {\n  font-family: 'DM Sans';\n  font-style: normal;\n  font-weight: 300;\n  src: url('../assets/DM_Sans/static/DMSans-Light.ttf');\n}\n\n@font-face {\n  font-family: 'DM Sans';\n  font-style: normal;\n  font-weight: 200;\n  src: url('../assets/DM_Sans/static/DMSans-ExtraLight.ttf');\n}\n\n@font-face {\n  font-family: 'DM Sans';\n  font-style: normal;\n  font-weight: 100;\n  src: url('../assets/DM_Sans/static/DMSans-Thin.ttf');\n}\n\n@font-face {\n  font-family: 'DM Sans';\n  font-style: italic;\n  font-weight: 900;\n  src: url('../assets/DM_Sans/static/DMSans-BlackItalic.ttf');\n}\n\n@font-face {\n  font-family: 'DM Sans';\n  font-style: italic;\n  font-weight: 800;\n  src: url('../assets/DM_Sans/static/DMSans-ExtraBoldItalic.ttf');\n}\n\n@font-face {\n  font-family: 'DM Sans';\n  font-style: italic;\n  font-weight: 700;\n  src: url('../assets/DM_Sans/static/DMSans-BoldItalic.ttf');\n}\n\n@font-face {\n  font-family: 'DM Sans';\n  font-style: italic;\n  font-weight: 600;\n  src: url('../assets/DM_Sans/static/DMSans-SemiBoldItalic.ttf');\n}\n\n@font-face {\n  font-family: 'DM Sans';\n  font-style: italic;\n  font-weight: 500;\n  src: url('../assets/DM_Sans/static/DMSans-MediumItalic.ttf');\n}\n\n@font-face {\n  font-family: 'DM Sans';\n  font-style: italic;\n  font-weight: 400;\n  src: url('../assets/DM_Sans/static/DMSans-Italic.ttf');\n}\n\n@font-face {\n  font-family: 'DM Sans';\n  font-style: italic;\n  font-weight: 300;\n  src: url('../assets/DM_Sans/static/DMSans-LightItalic.ttf');\n}\n\n@font-face {\n  font-family: 'DM Sans';\n  font-style: italic;\n  font-weight: 200;\n  src: url('../assets/DM_Sans/static/DMSans-ExtraLightItalic.ttf');\n}\n\n@font-face {\n  font-family: 'DM Sans';\n  font-style: italic;\n  font-weight: 100;\n  src: url('../assets/DM_Sans/static/DMSans-ThinItalic.ttf');\n}\n\n","@import 'variables';\n@import 'placeholders/fonts';\n@import 'placeholders/flexboxes';\n@import 'variables/breakpoints';\n@import '../../styles.scss';\n\n.banner-container {\n  display: flex;\n  justify-content: center; /* Center banner horizontally */\n  align-items: center; /* Center vertically */\n  padding: 20px;\n  border-radius: 25px;\n  background-size: cover;\n  background-position: center;\n  color: white;\n  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.4);\n  height:100px;\n  background-color: white;\n  border: 1px solid $theme-accent;\n}\n\n.banner-content {\n  display: flex;\n  flex-direction: column; /* Stack content vertically */\n  align-items: center; /* Center all elements horizontally */\n  width: 100%;\n  height:100%;\n}\n\n.logo {\n  //width:100px;\n  max-height:150px;\n}\n\nh1 {\n  font-size: 2rem;\n  margin: 0;\n  text-align: center; /* Center title text */\n}\n\n.grid-container {\n  width:100%;\n  height:100%;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  \n}\n\n.grid-item {\n  //border: 2px solid blue; /* Border for visibility */\n  display: flex;\n  flex-direction: column; /* Stack content in small items */\n  justify-content: center;\n  align-items: center;\n  color: white;\n  font-size: 1rem;\n}\n\n.grid-item.large {\n  display:flex;\n  margin: 0 20px;\n}\n\n.logo-container {\n  display:flex;\n  flex-direction: row;\n}\n\n.grid-item.small {\n  max-height: 150px;\n  margin: 0 10px;\n}\n\n.side-image {\n  \n  max-height:75px;\n  max-width:150px;\n  object-fit: contain;\n  \n}\n\n// Responsive Design\n@media screen and (max-width: $breakpoint-sm-max) {\n  .grid-container {\n    grid-template-columns: 1fr; /* Stack all items in one column */\n    grid-template-rows: auto; /* Let rows adjust automatically */\n  }\n\n  .grid-item.large {\n    grid-column: 1 / 2;\n    grid-row: 1 / 2; /* Title takes the first row */\n  }\n\n  .grid-item.small {\n    grid-column: 1 / 2; /* Small items stacked below */\n    grid-row: auto;\n  }\n}\n\n@media screen and (max-width: $breakpoint-md-max) {\n  h1 {\n    font-size: 1.5rem; /* Adjust title size for medium screens */\n  }\n}\n\n@media (max-width: 767px) {\n  .banner-container{\n    height:fit-content\n  }\n  .grid-container{\n    display:flex;\n    flex-direction:column;\n\n  }\n}\n","@import \"fonts\";\n\n// this file is more for variables that cannot be used in the theme\n// many of these should be migrated after the material theme has been configured.\n\n$font-family: \"Dm Sans\", sans-serif;\n\n/* Old palette\n$accent-btn: #DD7EB0;\n$dark-text: #303f71;\n$light-text: #fff;\n$inactive-text: #A3AED0;\n$accent-blue: #84D9FD;*/\n\n$accent-btn: #0CAD99;\n$dark-text: #1B3E78;\n$light-text: #fff;\n$inactive-text: #A3AED0;\n$accent-blue: #3792BF;\n\n$theme-main: #1B3E78;\n$theme-contrast: #0CAD99;\n$theme-1: #3792BF;\n$theme-2: #AACCFF;\n$theme-3: #BDBDBD;\n$theme-4: #7D7979;\n$theme-5: #787c95;\n\n$app-background: #F4F7FE;\n\n$rDNA-success: #00B300;\n$rDNA-alert: #FF0000;\n$rDNA-neutral: #FFBF00;\n","/*\n$theme-darkGray: #7D7979;\n$theme-lightGray: #BDBDBD;\n$theme-peach: #FFF2E1;\n$theme-yellow: #FFBB64;\n$theme-orange: #FF9001;\n$theme-blue: #2A296F;\n$sub-header-theme: #95a5a6;*/\n\n//----\n\n$theme-primary: #3792BF; \n$theme-secondary: #1B3E78; \n$theme-color3: #AACCFF; \n$theme-color4: #BDBDBD; \n$theme-color5: #7D7979; \n$theme-accent: #0CAD99; \n\n$text-gray:#787c95;"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
